import { z } from 'zod';

/**
 * Appearance preferences — the shared contract layer for B42's per-user
 * appearance settings.
 *
 * `theme` and `colour_blind_mode` live on `user_preferences` and are private to
 * the signed-in user. This file is deliberately not a general preferences
 * contract: the read shape exposes only the two B42 fields, and the patch
 * shapes are field-scoped strict objects so one preference route cannot
 * silently accept another route's key.
 */

/** `user_preferences.theme` — `ck_user_preferences_theme` restated. */
export const appearanceThemeSchema = z.enum(['light', 'dark', 'match_system']);

export type AppearanceTheme = z.infer<typeof appearanceThemeSchema>;

/** `GET /me/appearance-preferences`. */
export const appearancePreferencesSchema = z.object({
  theme: appearanceThemeSchema,
  colourBlindMode: z.boolean(),
});

export type AppearancePreferences = z.infer<typeof appearancePreferencesSchema>;

/** `PATCH /me/appearance-preferences/theme`. */
export const appearanceThemePatchSchema = z.strictObject({
  theme: appearanceThemeSchema,
});

export type AppearanceThemePatch = z.infer<typeof appearanceThemePatchSchema>;

/** `PATCH /me/appearance-preferences/colour-blind-mode`. */
export const colourBlindModePatchSchema = z.strictObject({
  colourBlindMode: z.boolean(),
});

export type ColourBlindModePatch = z.infer<typeof colourBlindModePatchSchema>;
